import React from "react";
import Vmarine from "../img/EPI.png";
import aguaDeLuz from "../img/Admin.png";
import todo from "../img/Gest-Vhe.jpg";
import PropTypes from "prop-types";
import {makeStyles, Grid,paper,Card,CardActionArea,CardActions,CardContent,Paper,CardMedia } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
	  flexGrow: 1,
	},
	paper: {
	  padding: theme.spacing(2),
	  textAlign: 'center',
	  color: theme.palette.text.secondary,
	},
  }));

export default class Projects extends React.Component {


	render() {
		return (
			<React.Fragment>



						<div id="my-projects" className="container-fluid bg-light mt-5" >
						<h1
							id="projects"
							className={"text-center " + this.props.fadeInRight}>
							Projects
						</h1>

					<div className=" project-container container bg-light pb-5">
						
					<Grid container spacing={3}>
<Grid item xs>
          <Paper 	className={"testbg col-12 col-sm-12 col-md-12 " +this.props.fadeIn}>
		 
								<div className="overlay">
									<div className="text">
										<h2>EPI</h2>
									</div>
									<div>
										<button
											id="vmarine-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var marineModal = document.getElementById(
													"vmarine"
												);
												modalBG.style.display = "block";
												marineModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							

		  </Paper>
        </Grid>
        <Grid item xs>
          <Paper className={ "aguabg col-12 col-sm-12 col-md-12 " +
									this.props.fadeIn + useStyles.paper}>
		  
								<div className="overlay">
									<div className="text">
										<h2>EPI  Admin</h2>
									</div>
									<div>
										<button
											id="agua-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var aguaModal = document.getElementById(
													"agualuz"
												);
												modalBG.style.display = "block";
												aguaModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							
		  </Paper>
        </Grid>
        <Grid item xs>
          <Paper className={"todobg col-12 col-sm-12 col-md-12 " +this.props.fadeIn + useStyles.paper}>
		 
								<div className="overlay">
									<div className="text">
										<h2>Vehicle-tracking</h2>
									</div>
									<div>
										<button
											id="todo-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var todoModal = document.getElementById(
													"todolist"
												);
												modalBG.style.display = "block";
												todoModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>

		  </Paper>
        </Grid>
      </Grid>
	  
					</div>
				</div>

				{/*hidden modals*/}
				<div id="gallery-card">
					<div id="vmarine" className="modal-card">
						<div className="visual">
							<img src={Vmarine} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Vmarine</h2>
							<div className="modal-description">
								<ul>
									<li>
									   <ul> EPI E-Shop web-application 
										<li>
										User interface to sell Industry  product and  provide information 
										   about progress of services and prices.
										</li>
										  <li>
										- Admin  Interface to  manage Products , Clients and Devis 
										  
										  </li>
									   </ul>
										
										
									</li>
									<li>
										Designed with HTML5, CSS3, Material UI,
										Nodejs, and MongoDB.
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
							<a
							href="https://episolution-hamza.herokuapp.com/menu"
							target="_blank">
							<h3>View Application</h3>
						</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var marineModal = document.getElementById(
											"vmarine"
										);
										modalBG.style.display = "none";
										marineModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>

					<div id="agualuz" className="modal-card">
						<div className="visual">
							<img src={aguaDeLuz} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Agua De Luz</h2>
							<div className="modal-description">
							<ul>
							<li>
							   <ul> EPI E-Shop web-application 
								<li>
								User interface to sell Industry  product and  provide information 
								   about progress of services and prices.
								</li>
								  <li>
								- Admin  Interface to  manage Products , Clients and Devis 
								  
								  </li>
							   </ul>
								
								
							</li>
							<li>
								Designed with HTML5, CSS3, Material UI,
								Nodejs, and MongoDB.
							</li>
						</ul>
							</div>
							<div className="modal-bottom">
								<a
									href="https://episolution-hamza.herokuapp.com/menu"
									target="_blank">
									<h3>View live demo</h3>
								</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var aguaModal = document.getElementById(
											"agualuz"
										);
										modalBG.style.display = "none";
										aguaModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>

					<div id="todolist" className="modal-card">
						<div className="visual">
							<img src={todo} alt=""/>
						</div>
						<div className="modal-info">
							<h2>To-Do List</h2>
							<div className="modal-description">
								<ul>
									<li>
										Application For fleet management (Drivers , vehicles )  .
									</li>
									<li>
										Developed with VB6
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
								
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var todoModal = document.getElementById(
											"todolist"
										);
										modalBG.style.display = "none";
										todoModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

Projects.propTypes = {
	bounceIn: PropTypes.string,
	fadeInLeft: PropTypes.string,
	fadeInRight: PropTypes.string,
	fadeIn: PropTypes.string,
	tada: PropTypes.string
};
